import React, { useEffect, useState } from 'react'
import Image from 'next/image'
import { styled } from '../../../../stitches.config'
import { ClipLoader } from 'react-spinners'
import { v4 as uuidv4 } from 'uuid';

const CardWrapper = styled('div', {
    display: 'contents',
    maxWidth: '100%',
})
const CardContainer = styled('div', {
    position: 'relative',
    variants: {
        size: {
            sm: {
                height: '141px',
                maxWidth: '200px',
            },
            md: {
                width: '300px',
                maxWidth: '100%',
            },
            lg: {
                width: '400px',
                maxWidth: '100%',
            },
        },
    },
    '& span': {
        display: 'block !important',
    },
    '& img': {
        maxWidth: '100%',
        height: 'auto',
    },
})
const Overlay = styled('div', {
    position: 'absolute',
    zIndex: 2,
    width: '100%',
    height: '100%',
    left: 0,
    top: 0,
})
const CardImageWrapper = styled('div', {
    display: 'flex',
    br: '25px',
    overflow: 'hidden',
    boxShadow: 'gray 0px 1px 5px -1px',
    m: 0,
})
const LogoWrapper = styled('div', {
    position: 'absolute',
    top: '9%',
    left: '9%',
    maxWidth: '37%',
    '& img': {
        maxWidth: '100%',
        maxHeight: '55px',
        width: 'auto',
        height: 'auto',
        '@media (max-width: 768px)': {
            maxHeight: '40px',
        },
    },
})
const ImgProgress = styled(ClipLoader, {
    position: 'absolute',
    top: '33%',
    left: '43%',
    zIndex: 1,
})
const ContentWrapper = styled('div', {
    position: 'absolute',
    width: '100%',
    bottom: '8%',
    left: '12%',
    fontSize: '7px',
    '& p': {
        color: 'white',
        textTransform: 'uppercase',
        letterSpacing: '1px',
        textShadow: '0px 0px 2px #000',
        m: '0 0 3px',
        p: 0,
        transform: 'scale(1, 1.3)',
    },
    '.date': {
        pb: '1.86%',
        pl: '38%',
    },
    '@media (min-width: 855px)': {
        fontSize: '9px',
    },
    '@media (min-width: 940px)': {
        fontSize: '11px',
    },
})

export interface CardProps {
    size: 'sm' | 'md' | 'lg'
    cardImageUrl: string
    logoImageUrl: string
    nameOnCard: string
    messageOnCard: string
    overlayType: 'full' | 'partial' | 'none'
}

const CardWithLogo = ({
    size = 'lg',
    cardImageUrl,
    logoImageUrl,
    nameOnCard,
    messageOnCard,
}: CardProps) => {
    const uniqueId = uuidv4()
    const [isLoading, setIsLoading] = useState(false)
    const cloudinaryHeight = 280
    const cloudinaryWidth = 400
    useEffect(() => {
        setIsLoading(true)
    }, [cardImageUrl])

    return (
        <CardWrapper>
            <CardContainer
                id={`card-${uniqueId}`}
                size={size}
                data-testid={'card'}
            >
                <Overlay>
                    <LogoWrapper>
                        {isLoading && (
                            <ImgProgress
                                id={'loader'}
                                color={'grey'}
                                loading={isLoading}
                                size={20}
                            />
                        )}
                        <Image
                            src={logoImageUrl}
                            height={cloudinaryHeight}
                            width={cloudinaryWidth}
                            alt={'card overlay image'}
                            onLoadingComplete={() => setIsLoading(false)}
                        />
                    </LogoWrapper>
                    <ContentWrapper>
                        <p className={'date'}>{'5/24'}</p>
                        <p>{nameOnCard ? nameOnCard : 'J. SMITH'}</p>
                        <p>
                            {messageOnCard ? messageOnCard : 'CUSTOM MESSAGE'}
                        </p>
                    </ContentWrapper>
                </Overlay>
                <CardImageWrapper>
                    <Image
                        alt="Plastic Visa Gift Card Image"
                        src={cardImageUrl}
                        height={282}
                        width={400}
                        draggable={false}
                        data-testid={'plastic-image'}
                        onLoadingComplete={() => setIsLoading(false)}
                    />
                </CardImageWrapper>
            </CardContainer>
        </CardWrapper>
    )
}

export default CardWithLogo
